var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 11.0001H11.7101L11.4301 10.7301C12.6301 9.33014 13.2501 7.42014 12.9101 5.39014C12.4401 2.61014 10.1201 0.390137 7.32014 0.0501373C3.09014 -0.469863 -0.469863 3.09014 0.0501373 7.32014C0.390137 10.1201 2.61014 12.4401 5.39014 12.9101C7.42014 13.2501 9.33014 12.6301 10.7301 11.4301L11.0001 11.7101V12.5001L15.2501 16.7501C15.6601 17.1601 16.3301 17.1601 16.7401 16.7501C17.1501 16.3401 17.1501 15.6701 16.7401 15.2601L12.5001 11.0001ZM6.50014 11.0001C4.01014 11.0001 2.00014 8.99014 2.00014 6.50014C2.00014 4.01014 4.01014 2.00014 6.50014 2.00014C8.99014 2.00014 11.0001 4.01014 11.0001 6.50014C11.0001 8.99014 8.99014 11.0001 6.50014 11.0001Z",
    fill: "#272163"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.e5ce0bab.svg";
export { ForwardRef as ReactComponent };